import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { SearchUtils } from "../PA.UIM.Core/SearchUtils"
import { PASearch } from "../PA.Core/PASearch"
import { PAEnvironment } from "../PA.Core/PAEnvironment"
import * as _ from "lodash"


const vUI_Funding_Rule_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_FUNDINGRULE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "WB Funding Rulle Id",
            columnResourceName: "colWbId",
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    FUNDING_RULE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "ID", columnResourceName: "colId", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    FUNDING_RULE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Name", columnResourceName: "colName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "WB MD Set Id",
            columnResourceName: "colWbMDSetId",
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "WB SalesOrg Id",
            columnResourceName: "colWbSalesOrgId",
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    EFFECTIVE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Valid From",
            columnResourceName: "colStartDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM/dd/yy"
        },
        domainOptions: {}
    },
    EFFECTIVE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Valid Thru",
            columnResourceName: "colEndDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM/dd/yy"
        },
        domainOptions: {}
    },
    FUNDTYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Fund Type",
            columnResourceName: "colFundTypeName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    FUNDINGACCOUNT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Source Customer Account",
            columnResourceName: "colfaName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    }
}

const FundingRuleSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: "WB_FUNDINGRULE_ID",
        id_ui: "FUNDING_RULE_ID",
        name: "FUNDING_FULE_NAME"
    },

    searchProviderFields: vUI_Funding_Rule_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where["WB_SALESORG_ID"] = { inq: _.map(usrContext.WB_SalesOrgs, "WB_SALESORG_ID") }
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                "vUI_FundingRule_Search",
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

const FundingRuleSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5SourceId: "FundingRuleSearchProfileByName" },

    profileFilter: [
        { profileFilterName: "ID", searchProviderFieldId: "FUNDING_RULE_ID", renderOptions: {} },
        { profileFilterName: "Name", searchProviderFieldId: "FUNDING_RULE_NAME", renderOptions: {} },
        { profileFilterName: "Valid Thru", searchProviderFieldId: "EFFECTIVE_END_DT", renderOptions: {} }
    ], //ISearchFields
    profileDisplayFields: [
        "FUNDING_RULE_ID", "FUNDING_RULE_NAME",
        "EFFECTIVE_START_DT", "EFFECTIVE_END_DT", "FUNDINGACCOUNT_NAME", "FUNDTYPE_NAME"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: FundingRuleSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const FundingRuleSearch: ISearch = {
    searchName: "Find Redistribution Rule",
    renderOptions: { ui5ResourceId: "FundingRuleSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [FundingRuleSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("FundingRuleBO", "FundingRule", FundingRuleSearch, "Redistribution Rules Search")

export { FundingRuleSearch }

